export interface IIntegrationSystemOverride {
    from_system?: string;
    to_system?: string;
}

function getStorageKey(companyId: string | undefined): string {
    return `integrationSystemOverrides:${companyId ?? ""}`;
}

export function loadIntegrationSystemOverrides(
    companyId: string | undefined
): Record<string, IIntegrationSystemOverride> {
    if (!companyId) return {};

    try {
        const raw = localStorage.getItem(getStorageKey(companyId));
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object") return {};
        return parsed as Record<string, IIntegrationSystemOverride>;
    } catch {
        return {};
    }
}

export function saveIntegrationSystemOverride(
    companyId: string | undefined,
    integrationId: number,
    patch: IIntegrationSystemOverride
): void {
    if (!companyId) return;

    const current = loadIntegrationSystemOverrides(companyId);
    const key = String(integrationId);
    const nextValue: IIntegrationSystemOverride = {
        ...(current[key] ?? {}),
        ...patch,
    };

    current[key] = nextValue;
    localStorage.setItem(getStorageKey(companyId), JSON.stringify(current));
}

export function applyIntegrationSystemOverrides(rows: IIntegration[], companyId: string | undefined): IIntegration[] {
    if (!companyId || rows.length === 0) return rows;

    const overrides = loadIntegrationSystemOverrides(companyId);

    return rows.map((row) => {
        const override = overrides[String(row.id)];

        return {
            ...row,
            from_system: override?.from_system ?? row.from_system ?? row.from ?? "",
            to_system: override?.to_system ?? row.to_system ?? row.to ?? "",
        };
    });
}
